import Grid from "@material-ui/core/Grid";
import get from "lodash/get";
import moment from "moment";
import React from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import calenderIcon from "../../../../../../../Assets/newicons/user-interface/calendar/outline/calendar-outline-16px.svg";

import {
  getFormattedDate,
  getFormattedImageLink,
} from "../../../../../../../Utils";
import "./index.css";

export const SigningAuthTimeline = ({ timeline = [0, 1, 2, 3, 4, 5] }) => (
  // const [name, setName] = useState('Mary');

  // function handleIconClick() {
  //   console.log("sdfs");
  // }

  <div className="width100 horizontal-middle">
    <VerticalTimeline layout="1-column">
      {timeline.map((data) => {
        const thisdata = get(data, "signingauthority[0]", {});
        const {
          employeefullname,
          effectivefrom,
          fallbackfullname,
          fallbackimagepath,
          imagepath,
          effectiveto,
        } = thisdata;
        const isPresent = !effectiveto;
        // authorizedforid
        const isPayslip = data.signingauthority.find(
          (x) => x.authorizedforid == 1,
        );
        const isForm16 = data.signingauthority.find(
          (x) => x.authorizedforid == 2,
        );

        const thisdata2 = get(data, "signingauthority2[0]", null);
        const isPresent2 = !get(thisdata2, "effectiveto", "");
        const isPayslip2 = get(data, "signingauthority2", []).find(
          (x) => x.authorizedforid == 1,
        );
        const isForm162 = get(data, "signingauthority2", []).find(
          (x) => x.authorizedforid == 2,
        );
        return (
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={
              isPresent ? { background: "#edf5fd" } : { background: "#f7f8f8" }
            }
            contentArrowStyle={{ borderRight: "7px solid  #f7f8f8" }}
            iconStyle={
              isPresent
                ? { background: "#1e8ced", color: "#fff" }
                : { background: "#edf5fd" }
            }
            icon={
              <span>
                {moment(effectivefrom, "YYYY-MM-DD").format(" MMM YYYY")}
              </span>
            }
          >
            <div>
              <div className="margin-top-4">
                <img
                  src={calenderIcon}
                  className="margin-right-8 margin-top-2 floatleft"
                ></img>
                <p className="small-dark-secondary t-bold">
                  {isPresent
                    ? "Present"
                    : `${getFormattedDate(effectivefrom)} - ${getFormattedDate(
                        effectiveto,
                      )}`}
                </p>
              </div>
              <Grid container spacing={3}>
                <Grid item md={6} sm={12}>
                  <div
                    className={
                      isPresent
                        ? "authority-details authority-active"
                        : "authority-details"
                    }
                  >
                    <div className="floatleft margin-right-8">
                      <img
                        className="profile-picture margin4"
                        src={getFormattedImageLink(imagepath)}
                        height="50"
                        width="50"
                      />
                    </div>
                    <div className="floatleft">
                      <div>
                        <span className="small-blue-dark t-bold floatleft">
                          {employeefullname}
                        </span>
                        <span className="grey-dot margin-left-8"></span>
                        <span className="floatleft small-dark-secondary t-bold">
                          Primary
                        </span>
                      </div>

                      {isPayslip && isForm16 ? (
                        <div className="margin-top-2 floatleft">
                          <span className="small-dark-disabled t-bold floatleft margin-right-10">
                            Payslip
                          </span>
                          <span className="grey-dot"></span>
                          <span className="small-dark-disabled t-bold floatleft margin-right-10">
                            Form 16
                          </span>
                        </div>
                      ) : (
                        <span className="small-dark-disabled t-bold floatleft margin-right-10 margin-top-2">
                          {isPayslip ? "Payslip" : "Form 16"}
                        </span>
                      )}
                    </div>
                  </div>
                </Grid>
                {fallbackfullname && (
                  <Grid item md={6} sm={12}>
                    <div
                      className="bg-color-white"
                      style={{ borderRadius: 4, height: 56, padding: 4 }}
                    >
                      <div className="floatleft margin-right-8">
                        <img
                          className="profile-picture"
                          src={getFormattedImageLink(fallbackimagepath)}
                          height="50"
                          width="50"
                        />
                      </div>
                      <div className="floatleft">
                        <div>
                          <span className="small-blue-dark t-bold floatleft">
                            {fallbackfullname}
                          </span>
                          <span className="grey-dot margin-left-8"></span>
                          <span className="floatleft small-dark-secondary">{`${employeefullname}'s signatory`}</span>
                        </div>

                        {isPayslip && isForm16 ? (
                          <div className="margin-top-2 floatleft">
                            <span className="small-dark-disabled t-bold floatleft margin-right-10">
                              Payslip
                            </span>
                            <span className="grey-dot"></span>
                            <span className="small-dark-disabled t-bold floatleft margin-right-10">
                              Form 16
                            </span>
                          </div>
                        ) : (
                          <span className="small-dark-disabled t-bold floatleft margin-right-10 margin-top-2">
                            {isPayslip ? "Payslip" : "Form 16"}
                          </span>
                        )}
                      </div>
                    </div>
                  </Grid>
                )}

                {thisdata2 && (
                  <Grid item md={6} sm={12}>
                    <div
                      className={
                        isPresent2
                          ? "authority-details authority-active"
                          : "authority-details"
                      }
                    >
                      <div className="floatleft margin-right-8">
                        <img
                          className="profile-picture margin4"
                          src={getFormattedImageLink(thisdata2.imagepath)}
                          height="50"
                          width="50"
                        />
                      </div>
                      <div className="floatleft">
                        <div>
                          <span className="small-blue-dark t-bold floatleft">
                            {thisdata2.employeefullname}
                          </span>
                          <span className="grey-dot margin-left-8"></span>
                          <span className="floatleft small-dark-secondary t-bold">
                            Primary
                          </span>
                        </div>

                        {isPayslip2 && isForm162 ? (
                          <div className="margin-top-2 floatleft">
                            <span className="small-dark-disabled t-bold floatleft margin-right-10">
                              Payslip
                            </span>
                            <span className="grey-dot"></span>
                            <span className="small-dark-disabled t-bold floatleft margin-right-10">
                              Form 16
                            </span>
                          </div>
                        ) : (
                          <span className="small-dark-disabled t-bold floatleft margin-right-10 margin-top-2">
                            {isPayslip2 ? "Payslip" : "Form 16"}
                          </span>
                        )}
                      </div>
                    </div>
                  </Grid>
                )}
                {thisdata2 && thisdata2.fallbackfullname && (
                  <Grid item md={6} sm={12}>
                    <div
                      className="bg-color-white"
                      style={{ borderRadius: 4, height: 56, padding: 4 }}
                    >
                      <div className="floatleft margin-right-8">
                        <img
                          className="profile-picture"
                          src={getFormattedImageLink(
                            thisdata2.fallbackimagepath,
                          )}
                          height="50"
                          width="50"
                        />
                      </div>
                      <div className="floatleft">
                        <div>
                          <span className="small-blue-dark t-bold floatleft">
                            {thisdata2.fallbackfullname}
                          </span>
                          <span className="grey-dot margin-left-8"></span>
                          <span className="floatleft small-dark-secondary">{`${thisdata2.employeefullname}'s signatory`}</span>
                        </div>
                        <div className="clear-float">
                          <span className="small-dark-disabled t-bold floatleft margin-right-10">
                            Payslip
                          </span>
                          <span className="small-dark-disabled t-bold floatleft margin-right-10">
                            <span className="grey-dot"></span>
                            <span className="floatleft">Form 16</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </Grid>
                )}
              </Grid>
            </div>
          </VerticalTimelineElement>
        );
      })}
    </VerticalTimeline>
  </div>
);

export default SigningAuthTimeline;
